// ======================================================================
// File Name       : ParticipantDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import * as ParticipantAction from '../../../actions/ParticipantAction';
import Header from '../../../components/Header';
import ParticipantDetailInfo from '../../../components/userHistory/participant/ParticipantDetailInfo';
import ParticipantDetailStatus from '../../../components/userHistory/participant/ParticipantDetailStatus';
import { RETURN_MAX_NUM } from '../../../constants/index';
import CustomLink from '../../../components/button/CustomLink';
import * as Path from '../../../constants/PathConstants';

class ParticipantDetailContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.createParams = this.createParams.bind(this);
    this.createParamRelation = this.createParamRelation.bind(this);
    this.getDetailOfParticipant = this.getDetailOfParticipant.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.resetParticipantDetail = this.resetParticipantDetail.bind(this);
  }
  componentWillMount() {
    const { match } = this.props;
    const userSecernId = match.params.id;
    // #7129 START
    this.resetParticipantDetail();
    // #7129 END
    this.getDetailOfParticipant(userSecernId);
  }

  // #7129 START
  componentWillUnmount() {
    this.resetParticipantDetail();
  }

  resetParticipantDetail() {
    this.props.dispatch(ParticipantAction.resetParticipantDetail());
  }
  // #7129 END

  getDetailOfParticipant(userSecernId) {
    if (userSecernId) {
      const param = this.createParams(userSecernId);
      const paramRelationStatus = this.createParamRelation(userSecernId, 0);
      this.props.dispatch(ParticipantAction.getParticipantDetail(param)).then(() => {
        this.props.dispatch(ParticipantAction.getParticipantStatus(paramRelationStatus));
      });
    }
  }

  createParams(userSecernId, startPosition) {
    const param = {
      searchInfo: {
        userSecernIdList: [userSecernId], // #6125
        startPosition,
        returnMaxNum: RETURN_MAX_NUM,
      },
    };
    return param;
  }

  createParamRelation(userSecernId, startPosition) {
    const param = {
      searchInfo: {
        userList: [userSecernId],
        startPosition,
        returnMaxNum: RETURN_MAX_NUM,
      },
    };
    return param;
  }

  getStartEndData(startPosition) {
    const { match } = this.props;
    const userSecernId = match.params.id;
    if (userSecernId) {
      const paramRelationStatus = this.createParamRelation(userSecernId, startPosition);
      this.props.dispatch(ParticipantAction.getParticipantStatusPaging(paramRelationStatus));
    }
  }

  backPage() {
    this.props.history.goBack();
  }

  render() {
    const { userList, liveList, liveRecordNum } = this.props;
    let userName = '';
    let groupNames = '';
    try {
      if (userList && userList.length && userList[0]) {
        userName = userList[0].userName;
        groupNames = userList[0].groupNames;
      }
    } catch (err) {
      return err;
    }

    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.PARTICIPANT_LIST}
          text="ユーザー別実績に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="ユーザー別ライブ履歴情報の詳細" />
        <ParticipantDetailInfo
          userName={userName}
          groupNames={groupNames}
        />
        <ParticipantDetailStatus
          liveList={liveList}
          liveRecordNum={liveRecordNum}
          getStartEndData={this.getStartEndData}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { userList, liveList, liveRecordNum } = state.participant;
  return {
    userList,
    liveList,
    liveRecordNum,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'participantDetail', // a unique identifier for this form
  enableReinitialize: true,
})(ParticipantDetailContainer));
